(() => {
  if (window.tekokukatFavoritesInitialized) return;
  window.tekokukatFavoritesInitialized = true;
  const stringsNode = document.getElementById('CardFavoriteStrings');
  if (!stringsNode) return;
  const strings = JSON.parse(stringsNode.textContent);
  const storageKey = 'tekokukat:favorites:v1';
  const heart = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M20.8 4.9a5.5 5.5 0 0 0-7.8 0L12 6l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.3a5.5 5.5 0 0 0 0-7.8Z"/></svg>';
  const cross = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"/></svg>';
  const safeLink = value => {
    try { const url = new URL(value, location.origin); return url.origin === location.origin && url.pathname.startsWith('/products/') ? url.href : null; } catch { return null; }
  };
  const safeImage = value => {
    try { const url = new URL(value, location.origin); return ['https:', 'http:'].includes(url.protocol) && (url.origin === location.origin || url.hostname === 'cdn.shopify.com') ? url.href : null; } catch { return null; }
  };
  let saved = [];
  const read = () => {
    try { const values = JSON.parse(localStorage.getItem(storageKey) || '[]'); return Array.isArray(values) ? values.filter(item => item && /^\d+$/.test(String(item.id)) && typeof item.title === 'string' && safeLink(item.url)).slice(0, 100) : []; } catch { return saved; }
  };
  saved = read();
  const status = document.createElement('span');
  status.className = 'visually-hidden';
  status.setAttribute('role', 'status');
  document.body.append(status);
  const dialog = document.createElement('dialog');
  dialog.className = 'card-favorites';
  dialog.setAttribute('aria-labelledby', 'CardFavoritesHeading');
  const header = document.createElement('div');
  header.className = 'card-favorites__header';
  const heading = document.createElement('h2');
  heading.id = 'CardFavoritesHeading';
  heading.textContent = strings.title;
  const close = document.createElement('button');
  close.type = 'button';
  close.className = 'card-favorites__close';
  close.setAttribute('aria-label', strings.close);
  close.innerHTML = cross;
  header.append(heading, close);
  const list = document.createElement('ul');
  list.className = 'card-favorites__list';
  const empty = document.createElement('p');
  empty.textContent = strings.empty;
  const note = document.createElement('p');
  note.className = 'card-favorites__note';
  note.textContent = strings.note;
  dialog.append(header, empty, list, note);
  document.body.append(dialog);
  let opener;
  const openDialog = event => { opener = event.currentTarget; renderList(); dialog.showModal(); close.focus(); };
  close.addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => opener?.focus({ preventScroll: true }));
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
  });
  const favoriteButtons = new Set();
  const favoriteCounts = new Set();
  let selectedIds = new Set(saved.map(item => item.id));
  const updateButton = button => {
    const selected = selectedIds.has(button.dataset.productId);
    const pressed = String(selected);
    const label = selected ? button.dataset.removeLabel : button.dataset.saveLabel;
    if (button.getAttribute('aria-pressed') !== pressed) button.setAttribute('aria-pressed', pressed);
    if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
    if (!button.hasAttribute('data-ready')) button.setAttribute('data-ready', '');
  };
  const updateCount = count => {
    const value = String(saved.length);
    if (count.textContent !== value) count.textContent = value;
    if (count.hidden !== (saved.length === 0)) count.hidden = saved.length === 0;
  };
  const initialize = root => {
    const selector = '[data-card-favorite], .header__icons';
    const elements = root.firstElementChild ? root.querySelectorAll(selector) : [];
    const register = element => {
      if (element.matches('[data-card-favorite]')) {
        favoriteButtons.add(element);
        updateButton(element);
        return;
      }
      const icons = element;
      if (icons.querySelector('.card-favorites-open')) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'header__icon header__icon--wishlist link focus-inset card-favorites-open';
      button.setAttribute('aria-label', strings.title);
      button.setAttribute('aria-haspopup', 'dialog');
      button.innerHTML = heart;
      const count = document.createElement('span');
      count.className = 'card-favorites-count';
      count.setAttribute('aria-hidden', 'true');
      favoriteCounts.add(count);
      updateCount(count);
      button.append(count);
      button.addEventListener('click', openDialog);
      icons.insertBefore(button, icons.querySelector('#cart-icon-bubble'));
    };
    if (root instanceof Element && root.matches(selector)) register(root);
    elements.forEach(register);
  };
  const prune = () => {
    for (const button of favoriteButtons) if (!button.isConnected) favoriteButtons.delete(button);
    for (const count of favoriteCounts) if (!count.isConnected) favoriteCounts.delete(count);
  };
  const sync = () => {
    selectedIds = new Set(saved.map(item => item.id));
    prune();
    favoriteButtons.forEach(updateButton);
    favoriteCounts.forEach(updateCount);
  };
  const persist = () => {
    try { localStorage.setItem(storageKey, JSON.stringify(saved)); } catch { note.hidden = true; }
    sync();
  };
  function renderList() {
    list.replaceChildren();
    empty.hidden = saved.length !== 0;
    saved.forEach(item => {
      const row = document.createElement('li');
      const link = document.createElement('a');
      link.href = safeLink(item.url);
      const imageUrl = safeImage(item.image);
      if (imageUrl) {
        const image = document.createElement('img');
        image.src = imageUrl;
        image.alt = '';
        image.width = 64;
        image.height = 64;
        image.loading = 'lazy';
        link.append(image);
      }
      const title = document.createElement('span');
      title.textContent = item.title;
      link.append(title);
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'card-favorites__remove';
      remove.setAttribute('aria-label', strings.remove + ': ' + item.title);
      remove.innerHTML = cross;
      remove.addEventListener('click', () => {
        saved = saved.filter(value => value.id !== item.id);
        persist();
        renderList();
        (list.querySelector('button') || close).focus();
      });
      row.append(link, remove);
      list.append(row);
    });
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-card-favorite]');
    if (!button) return;
    event.preventDefault();
    const id = button.dataset.productId;
    const selected = saved.some(item => item.id === id);
    if (selected) saved = saved.filter(item => item.id !== id);
    else if (safeLink(button.dataset.productUrl)) saved = [...saved, { id, title: button.dataset.productTitle, url: button.dataset.productUrl, image: button.dataset.productImage }].slice(-100);
    persist();
    status.textContent = selected ? strings.removed : strings.saved;
  });
  window.addEventListener('storage', event => { if (event.key === storageKey) { saved = read(); sync(); if (dialog.open) renderList(); } });
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  const pendingRoots = new Set();
  let scheduled = false;
  const flush = () => {
    scheduled = false;
    for (const root of pendingRoots) {
      if (!root.isConnected) continue;
      let ancestor = root.parentElement;
      while (ancestor && !pendingRoots.has(ancestor)) ancestor = ancestor.parentElement;
      if (!ancestor) initialize(root);
    }
    pendingRoots.clear();
    prune();
  };
  new MutationObserver(records => {
    for (const record of records) {
      if (record.target instanceof Element && record.target.closest('.card-favorites, .card-favorites-open')) continue;
      for (const node of record.addedNodes) {
        if (!(node instanceof Element) || node.matches('script, style, link, svg, .card-favorites-open')) continue;
        pendingRoots.add(node);
      }
    }
    if (!pendingRoots.size || scheduled) return;
    scheduled = true;
    requestAnimationFrame(flush);
  }).observe(document.body, { childList: true, subtree: true });
  initialize(document);
})();
